import { Pipe, PipeTransform } from '@angular/core';
import { AcdTypeEnum } from '../../samwebDescription/samwin/AcdTypeEnum';

@Pipe({
   name: 'toAcdType',
})
export class ToAcdTypePipe implements PipeTransform {
   transform(acdType: string): AcdTypeEnum {
      return AcdTypeEnum.getAcdTypeFromAcdLine(acdType);
   }
}
